/* eslint-disable */
import ol from "./ol";

 function MapboxStyle(customStyle) {
    console.log('customStyles',customStyle);
  var fill = new ol.style.Fill({ color: '' });
  var stroke = new ol.style.Stroke({ color: '', width: 1 });
  var polygon = new ol.style.Style({ fill: fill });
  var strokedPolygon = new ol.style.Style({ fill: fill, stroke: stroke });
  var line = new ol.style.Style({ stroke: stroke });
  var text = new ol.style.Style({
      text: new ol.style.Text({
          text: '', fill: fill, stroke: stroke
      })
  });
  var iconCache = {};
  function getIcon(iconName) {
      var icon = iconCache[iconName];
      if (!icon) {
          icon = new ol.style.Style({
              image: new ol.style.Icon({
                  src: 'https://cdn.rawgit.com/mapbox/maki/master/icons/' + iconName + '-15.svg',
                  imgSize: [15, 15]
              })
          });
          iconCache[iconName] = icon;
      }
      return icon;
  }
  function getData(index, values, zoom) {
      for (let i = index; i < values.length; i += 2) {
          const data = values[i];
          if (i === values.length - 2 && zoom >= data) {
              return values[i + 1]
          }
          if (zoom <= data) {
              return values[i + 1]
          }
      }
  }
  function getMatch(paints, cls) {
      let _dv = paints[paints.length - 1]
      if (paints[1][0] === "get") {
          let _v = cls.get(paints[1][1]);
          for (let i = 2; i < paints.length; i += 2) {
              const _n = paints[i];
              if (Array.isArray(_n)) {
                  if (_n.indexOf(_v) != -1) {
                      return paints[i + 1]
                  }
                  return _dv
              } else if (_v === paints[i]) {
                  return paints[i + 1]
              }
          }
      }
      return _dv
  }

  function getExponential(index, base, values, zoom, cls) {
      let curIndex = index
      let lowlevel = values[curIndex];
      let uplevel = values[values.length - 2];
      if (zoom <= lowlevel) {
          return values[curIndex + 1]
      }
      if (zoom >= uplevel) {
          return values[values.length - 1]
      }
      for (let i = index; i < values.length; i += 2) {
          curIndex = i;
          lowlevel = values[curIndex];
          if (i === values.length - 2) {
              curIndex = i - 2;
              break;
          }
          if (zoom <= lowlevel) {
              break;
          }
      }
      lowlevel = values[curIndex];
      uplevel = values[curIndex + 2];
      let lowVal = values[curIndex + 1]
      let upVal = values[curIndex + 3]
      if (Array.isArray(lowVal)) {
          lowVal = getPaint(lowVal, zoom, cls)
      }
      if (Array.isArray(upVal)) {
          upVal = getPaint(upVal, zoom, cls)
      }
      let dif = uplevel - lowlevel
      let pro = zoom - lowlevel
      let t = (Math.pow(base, pro) - 1) / (Math.pow(base, dif) - 1);
      if (dif === 0) {
          t = 0
          //  return lowVal * (1 - t) + upVal * t
      } else if (base === 1) {
          t = pro / dif
          //   return lowVal * (1 - t) + upVal * t
      }
      if (values[1][0] === "cubic-bezier") {
          //  let cb = getPaint(3, values, zoom);
          let ub = new UnitBezier(values[1][1], values[1][2], values[1][3], values[1][4])
          t = ub.solve(t)

      }
      return lowVal * (1 - t) + upVal * t

  }
  function getInterpolate(paints, level, cls) {
      if (paints[1][0] === "linear") {
          let _ds = getData(3, paints, level);
          // if (Array.isArray(_ds)) {
          //     _ds = getPaint(_ds, level, cls)
          // }
          if (typeof _ds === 'number') {
              return getExponential(3, 1, paints, level, cls)
          }
          return _ds
      }
      else {//if (paints[1][0] === "exponential") {
          // let _ds = getData(3, paints, level);

          //  console.log((Math.pow(paints[1][1],level-getData(3, paints, level))-1)-(Math.pow(paints[1][1],getData(3, paints, level)-level)-1))
          return getExponential(3, paints[1][1], paints, level, cls)
      }
      // else if (paints[1][0] === "cubic-bezier") {
      //     let _ds = getData(3, paints, level);
      //     if (Array.isArray(_ds)) {
      //         return getPaint(_ds, level, cls)
      //     }
      //     return paints[paints.length - 1]
      // }
      return paints;

  }
  function getCoalesce(index, values, cls) {
      for (let i = index; i < values.length; i++) {
          const data = values[i];
          let f = data[1]
          if (f === 'name_en') {
              f = 'name_zh-Hans'
          }
          let _v = cls.get(f)
          if (data[0] === "get" && _v) {
              return _v
          }
      }
  }
  function getPaint(paints, level, cls) {
      const start = paints[0];
      if (start === 'match') {
          let _setp = getMatch(paints, cls)
          if (Array.isArray(_setp)) {
              return getPaint(_setp, level, cls)
          }
          return _setp
      }
      else if (start === 'interpolate') {
          let _setp = getInterpolate(paints, level, cls)
          if (Array.isArray(_setp)) {
              return getPaint(_setp, level, cls)
          }
          return _setp
      }
      //  return getInterpolate(paints, level, cls)
      else if (start === 'step') {
          let _setp = getStep(paints, level, cls)
          if (Array.isArray(_setp)) {
              return getPaint(_setp, level, cls)
          }
          return _setp
      }
      else if (start === 'get') {
          let f = paints[1]
          if (f === 'name_en') {
              f = 'name_zh-Hans'
          }
          let _v = cls.get(f)
          return _v
      }
      else if (start === 'coalesce') {
          return getCoalesce(1, paints, cls)
      }
      return paints;
  }
  function getStep(paints, level, cls) {
      let _v = level
      if (paints[1][0] === "get") {
          _v = cls[paints[1][1]]
      }
      for (let i = 3; i < paints.length; i += 2) {
          if (_v >= paints[i]) {
              return paints[i + 1]
          }

      }
      return paints[2]
  }
  function getF(filters, cls, level,fill,stroke) {
    // console.log('getF',filters);
      var geom = cls.getGeometry().getType();
      var properties = cls.getProperties()
    //   console.log('geom',geom,properties,properties[filters[1]]);
      switch (filters[0]) {
          case "all":
              {
                  for (let i = 1; i < filters.length; i++) {
                      if (!getF(filters[i], cls, level))
                          return false;
                  }
                  return true;
              }
          case "match":
              {
                //   let _match=getPaint(filters, level, cls);
                  let _match=getMatch(filters, cls);
                  if (Array.isArray(_match)) {
                      return getF(_match, cls, level)
                  }
                  return _match
                  if (Array.isArray(_match)) {
                      console.log(0)
                  }
                  return _match
              }
          case "step":
              {
                  let _setp = getStep(filters, level, cls)
                  if (Array.isArray(_setp)) {
                      return getF(_setp, cls, level)
                  }
                  return _setp
              }
          case '==':
              {
                // if(properties[filters[1]] == filters[2] ){
                //     // if(geom == "Polygon"){
                //         let _result = cls
                //         return _result
                //     // }
                // }
                
                  if (filters[1][0] === "get" && cls.get(filters[1][1]) === filters[2]) {
                      return true;
                  } else if (filters[1][0] === "geometry-type" && geom.indexOf(filters[2]) != -1) {
                      return true;
                  }
                 
              }
              break
          case '<=':
              let v = cls.get(filters[1][1])
              if (Array.isArray(filters[2])) {
                  if (filters[2][0] === "+") {
                      v += getPaint(filters[2][1], level, cls);
                  }
              }
              if (filters[1][0] === "get" && v <= filters[2]) {
                  return true;
              }
              break
          case '>=':
              if (filters[1][0] === "get" && cls.get(filters[1][1]) >= filters[2]) {
                  return true;
              }
              break
          case '!=':
              if (filters[1][0] === "get" && cls.get(filters[1][1]) != filters[2]) {
                  return true;
              } else if (filters[1][0] === "geometry-type" && geom.indexOf(filters[2]) == -1) {
                  return true;
              }
              break


      }
      return false;
  }
  function getFilter(filters, cls, level,fill,stroke) {
      return getF(filters, cls, level,fill,stroke)
  }
  var styles = [];
  return (feature, resolution, level, style) => {
    // console.log('mvtstyle',feature,customStyle,level);
    var length = 0;
    let properties = feature.properties_;
    let type = feature.type_;
    var geom = feature.getGeometry().getType();
      // var length = 0;
      var layer = feature.get('layer');
      var maki = feature.get('maki');
      // var geom = feature.getGeometry().getType();
    //   let l_type = customStyle.type
      // if (geom === "Polygon") {
      //     l_type = 'fill'
      // }
      // else if (geom.indexOf("LineString") != -1) {
      //     l_type = 'line'
      // }
      // else {
      //     l_type = 'symbol'
      // }
      // geom console.log(layer+geom)
      // let lys = style.layers.filter(p => p["source-layer"] === layer && p.type === l_type).sort((a, b) => a.minzoom || 0 - b.minzoom || 0)
      // console.log('lys',lys);
      //多层加了循环之后再去一个一个渲染非常非常慢
    //   for (let j = 0; j < customStyles.length; j++) {
      //     const _ly = lys[j];
            // const customStyle = customStyles[j]
            // console.log('forstyle',customStyle);
          // if ((customStyle.filter && !getFilter(customStyle.filter, feature, level)) || (customStyle.minzoom && customStyle.minzoom > level) || (customStyle.maxzoom && customStyle.maxzoom < level)) {

          //     continue;
          // }
          try {
              var fill = new ol.style.Fill({ color: '' });
              var stroke = new ol.style.Stroke({ color: '', width: 1 });
              var polygon = new ol.style.Style({ fill: fill });
              var strokedPolygon = new ol.style.Style({ fill: fill, stroke: stroke });
              var line = new ol.style.Style({ stroke: stroke });
              var text = new ol.style.Style({
                  text: new ol.style.Text({
                      text: '', fill: fill, stroke: stroke
                  })
              });
              // _ly.minzoom = _ly.minzoom || 0
              // _ly.maxzoom = _ly.maxzoom || 40
              //!getFilter(_ly.filter, feature)||

              if(customStyle.filter){
                const result = getFilter(customStyle.filter,feature,level)
                // console.log('result',result);
                if(result){
                    if (customStyle.type === "line") {
                        let color = getPaint(customStyle.paint['line-color'], level, feature);
                        let op = 1
                        if (customStyle.paint['line-opacity']) {
                            op = getPaint(customStyle.paint['line-opacity'], level, feature);
      
                            if (op != 1 && color.indexOf('hsla') == -1) {
                                color = color.replace('hsl', 'hsla').replace(')', ',' + op + ")")
                            }
                            else if (op != 1) {
                                let ss = color.split(',')
                                ss[ss.length - 1] = op + ")"
                                color = ss.join()
                            }
                        }
                        stroke.setColor(color);
                        if (customStyle.paint['line-width']) {
                            let w = getPaint(customStyle.paint['line-width'], level, feature);
                            stroke.setWidth(w);
                        }
                        if (customStyle.layout['line-cap'])
                            stroke.setLineCap(getPaint(customStyle.layout['line-cap'], level, feature));
                        if (customStyle.layout['line-join'])
                            stroke.setLineJoin(getPaint(customStyle.layout['line-join'], level, feature));
                        if (customStyle.paint['line-dasharray']) {
                            let das = getPaint(customStyle.paint['line-dasharray'], level, feature);
                            if (das[0] === "literal") {
                                das = das[1]
                            }
                            stroke.setLineDash(das);
                        }
      
                        styles[length++] = line;
                    }else if(customStyle.type === "fill"){
                        // console.log('fillColor');
                        let color = getPaint(customStyle.paint['fill-color'], level, feature);
                        if (customStyle.paint['fill-opacity']) {
                            let op = getPaint(customStyle.paint['fill-opacity'], level, feature);
      
                            if (op != 1 && color.indexOf('hsla') == -1) {
                                color = color.replace('hsl', 'hsla').replace(')', ',' + op + ")")
                            }
                            else if (op != 1) {
                                let ss = color.split(',')
                                ss[ss.length - 1] = op + ")"
                                color = ss.join()
                            }
                        }
                        fill.setColor(color);
                        if (customStyle.paint['fill-outline-color']) {
                            let _color = getPaint(customStyle.paint['fill-outline-color'], level, feature);
                            let w = customStyle.paint['fill-outline-width'] ? getPaint(customStyle.paint['fill-outline-width'], level, feature) :0.5;
                            if (customStyle.paint['fill-outline-opacity']) {
                              let op = getPaint(customStyle.paint['fill-outline-opacity'], level, feature);
        
                              if (op != 1 && _color.indexOf('hsla') == -1) {
                                  _color = _color.replace('hsl', 'hsla').replace(')', ',' + op + ")")
                              }
                              else if (op != 1) {
                                  let ss = _color.split(',')
                                  ss[ss.length - 1] = op + ")"
                                  _color = ss.join()
                              }
                          }
                            stroke.setColor(_color);
                          //   stroke.setWidth(0.5);
                            stroke.setWidth(w);
                            styles[length++] = strokedPolygon;
                        } else {
                            styles[length++] = polygon;
                        }
                    }
                }
            //    console.log('filter11111',getFilter(customStyle.filter,feature,level)); 
              }
              else if (customStyle.type === "fill") {
                  let color = getPaint(customStyle.paint['fill-color'], level, feature);
                  if (customStyle.paint['fill-opacity']) {
                      let op = getPaint(customStyle.paint['fill-opacity'], level, feature);

                      if (op != 1 && color.indexOf('hsla') == -1) {
                          color = color.replace('hsl', 'hsla').replace(')', ',' + op + ")")
                      }
                      else if (op != 1) {
                          let ss = color.split(',')
                          ss[ss.length - 1] = op + ")"
                          color = ss.join()
                      }
                  }
                  fill.setColor(color);
                  if (customStyle.paint['fill-outline-color']) {
                      let _color = getPaint(customStyle.paint['fill-outline-color'], level, feature);
                      let w = customStyle.paint['fill-outline-width'] ? getPaint(customStyle.paint['fill-outline-width'], level, feature) :0.5;
                      if (customStyle.paint['fill-outline-opacity']) {
                        let op = getPaint(customStyle.paint['fill-outline-opacity'], level, feature);
  
                        if (op != 1 && _color.indexOf('hsla') == -1) {
                            _color = _color.replace('hsl', 'hsla').replace(')', ',' + op + ")")
                        }
                        else if (op != 1) {
                            let ss = _color.split(',')
                            ss[ss.length - 1] = op + ")"
                            _color = ss.join()
                        }
                    }
                      stroke.setColor(_color);
                    //   stroke.setWidth(0.5);
                      stroke.setWidth(w);
                      styles[length++] = strokedPolygon;
                  } else {
                      styles[length++] = polygon;
                  }
              }
              else if (customStyle.type === "line") {
                let color = getPaint(customStyle.paint['line-color'], level, feature);
                let op = 1
                if (customStyle.paint['line-opacity']) {
                    op = getPaint(customStyle.paint['line-opacity'], level, feature);

                    if (op != 1 && color.indexOf('hsla') == -1) {
                        color = color.replace('hsl', 'hsla').replace(')', ',' + op + ")")
                    }
                    else if (op != 1) {
                        let ss = color.split(',')
                        ss[ss.length - 1] = op + ")"
                        color = ss.join()
                    }
                }
                stroke.setColor(color);
                if (customStyle.paint['line-width']) {
                    let w = getPaint(customStyle.paint['line-width'], level, feature);
                    stroke.setWidth(w);
                }
                if (customStyle.layout['line-cap'])
                    stroke.setLineCap(getPaint(customStyle.layout['line-cap'], level, feature));
                if (customStyle.layout['line-join'])
                    stroke.setLineJoin(getPaint(customStyle.layout['line-join'], level, feature));
                if (customStyle.paint['line-dasharray']) {
                    let das = getPaint(customStyle.paint['line-dasharray'], level, feature);
                    if (das[0] === "literal") {
                        das = das[1]
                    }
                    stroke.setLineDash(das);
                }

                styles[length++] = line;
              }
              else if (maki) {
                  styles[length++] = getIcon(maki);
              }
              else if (layer.endsWith('_label') || customStyle.type === 'symbol') { // 省市县 城市名称 标注 
                // console.log('text',text,feature);
                  let txtStyle= text.getText();
                //   console.log('text',txtStyle);
                //   txtStyle.setText(getPaint(customStyle.layout['text-field'], level, feature));
                  txtStyle.setText(feature.get("name"));
                 
                  if (customStyle.layout['text-size']) {
                      let fontsize = getPaint(customStyle.layout['text-size'], level-4, feature)
                    //   txtStyle.setFont('normal ' + fontsize + 'px "Open Sans", "Arial Unicode MS"');
                      txtStyle.setFont('bold 11px "Open Sans", "Arial Unicode MS"');
                  }
                  if (customStyle.layout['text-offset']) {
                      let off = getPaint(customStyle.layout['text-offset'], level, feature)
                      if (off[0] === "literal") {
                          off = off[1]
                      }
                    //   txtStyle.setOffsetX(off[0])
                    //   txtStyle.setOffsetY(off[1])
                  }
                 
                //   fill.setColor(getPaint(customStyle.paint['text-color'], level, feature));
                  fill.setColor('#334');
                  stroke.setColor('rgba(255,255,255,0.8)');
                  stroke.setWidth(2);
                //   console.log('text',text);

                  styles[length++] = text;
              }

          } catch (e) {
              console.log(e)
          }
    //  }
      
      styles.length = length
      return styles;
  };
}
export default MapboxStyle;